<template>
  <article class="index-container">
    <!-- swiper -->
    <section class="section-swiper">
      <swiper 
        :pagination="{ clickable: true }"
        :autoplay="true"
        :loop="true"
      >
        <swiper-slide>
          <div class="banner banner-cup"> 
            <router-link to="./index">
              <div class="inner">
                <img :src="require('@/assets/imgs/index/banner-cup-content.svg')" alt=""> 
							</div>
            </router-link>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner banner-face"> 
            <article class="inner">
              <div class="left">
                <p class="title">人脸识别</p>
                <p class="subtitle">检测面部五官、轮廓关键点，并识别人脸属性、性别、年龄段。</p>
                <a class="btn-detail" @click="gotoProductDetail('face')"><span>查看详情</span></a>
              </div>
              <div class="right"><img :src="require('@/assets/imgs/index/banner-face.svg')" alt=""></div>
            </article>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner banner-feature"> 
            <article class="inner">
              <div class="left">
                <p class="title">特征抽取</p>
                <p class="subtitle">抽取文字中的实体信息及更复杂的组合信息</p>
                <a class="btn-detail" @click="gotoProductDetail('feature')"><span>查看详情</span></a>
              </div>
              <div class="right"><img :src="require('@/assets/imgs/index/banner-feature.svg')" alt=""></div>
            </article>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner banner-speak"> 
            <article class="inner">
              <div class="left">
                <p class="title">语速检测</p>
                <p class="subtitle">快速检测说话速度，无需依赖文本</p>
                <a class="btn-detail" @click="gotoProductDetail('speak')"><span>查看详情</span></a>
              </div>
              <div class="right"><img :src="require('@/assets/imgs/index/banner-speak.svg')" alt=""></div>
            </article>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="banner banner-into"> 
            <article class="inner">
              <div class="left line">
                <p class="title">全国政协委员调研团走进信也科技</p>
                <p class="subtitle">科技驱动，助力经济</p>
                <a class="btn-detail" href="//mp.weixin.qq.com/s/rpNL2qOF8AaaOmP8qnYHeQ" target="_blank"><span>查看详情</span></a>
              </div>
            </article>
          </div>
        </swiper-slide>
      </swiper>
    </section>
    <!-- 明星产品 -->
    <section class="section-star">
      <div class="inner">
        <div class="title"><span>明星产品</span></div>
        <div class="subtitle">优质、高可用、能落地的丰富的AI技术及算法，为业务赋能</div>
        <ul class="mode-list"> 
          <li class="mode-item mode-item-active">
            <div class="mode-wrap clearfix">
              <div class="mode-view">
                <div class="view-title">自然语言处理</div>
                <div class="view-desc">全面综合、开箱即用的NLP综合能力，满足多种文本智能需求</div>
              </div>
              <div class="mode-detail">
                <div class="detail-title">自然语言处理</div>
                <div class="detail-desc">全面综合、开箱即用的NLP综合能力，满足多种文本智能需求</div>
                <div class="detail-content">
                  <ul class="ai-list">
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">意图识别</div>
                        <div class="item-content">识别对方意图，目前支持中文和印尼语</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <div class="item-title">文本挖掘、分析和分类</div>
                      <div class="item-content">利用文本聚类和规则，构造文本集合的意图分类</div>
                    </li>
                    <li class="ai-item existing">
                      <router-link :to="{name:'feature'}" target="_blank">
                        <div class="item-title">特征抽取</div>
                        <div class="item-content">抽取文字中的实体信息及更复杂的组合信息，例如命名实体、逾期时间、金额、事件类信息等</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <div class="item-title">实体识别</div>
                      <div class="item-content">利用BERT模型，提供中文命名实体识别服务</div>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">文本自动打标签</div>
                        <div class="item-content">给文本打任意分类标签</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <div class="item-title">句向量服务</div>
                      <div class="item-content">提供文本的句向量表示,目前主要应用于各种NLP任务的预研,</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="mode-item">
            <div class="mode-wrap">
              <div class="mode-view">
                <div class="view-title">图像识别</div>
                <div class="view-desc">综合图像理解和分析服务，提升用户体验和效率</div>
              </div>
              <div class="mode-detail">
                <div class="detail-title">图像识别</div>
                <div class="detail-desc">综合图像理解和分析服务，提升用户体验和效率</div>
                <div class="detail-content">
                  <ul class="ai-list">
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">OCR</div>
                        <div class="item-content">可识别常见的证件，并输出证件上的信息</div>
                      </router-link>
                    </li>
                    <li class="ai-item existing">
                      <router-link :to="{name:'face'}" target="_blank">
                        <div class="item-title">人脸识别</div>
                        <div class="item-content">检测面部五官、轮廓关键点，并识别人脸属性、性别、年龄段</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">场景识别</div>
                        <div class="item-content">对目标图片属性、背景进行识别</div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
          <li class="mode-item">
            <div class="mode-wrap">
              <div class="mode-view">
                <div class="view-title">语音识别</div>
                <div class="view-desc">专业智能高效的语音处理服务</div>
              </div>
              <div class="mode-detail">
                <div class="detail-title">语音识别</div>
                <div class="detail-desc">专业智能高效的语音处理服务</div>
                <div class="detail-content">
                  <ul class="ai-list">
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">声纹检测</div>
                        <div class="item-content">判断多段语音是否来自同一个自然人</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">人声识别</div>
                        <div class="item-content">判断语音是否是人声</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">情绪检测</div>
                        <div class="item-content">判断一段语音的情绪</div>
                      </router-link>
                    </li>
                    <li class="ai-item existing">
                      <router-link :to="{name:'speak'}" target="_blank">
                        <div class="item-title">语速检测</div>
                        <div class="item-content">判断一段语音的语速</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">中文TTS</div>
                        <div class="item-content">将一段中文文本转化为人声</div>
                      </router-link>
                    </li>
                    <li class="ai-item">
                      <router-link to="./index">
                        <div class="item-title">印尼语音识别</div>
                        <div class="item-content">可提供印尼语音识别服务</div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <!-- 热门技术运维产品 -->
    <section class="section-hot">
      <div class="hot-head">
        <div class="inner">
          <div class="title"><span>热门技术运维产品</span></div>
          <div class="subtitle">技术产品是整个业务流转和运作的基石，架构起广阔丰富的产品体系</div>
          <div class="tabs-bar">
            <ul class="tabs-list">
              <li class="tabs-item tabs-item-active" data-key="jcjg">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/jcjg.svg')" alt=""> 
                  </div>
                  <p class="tabs-item-title">基础架构</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="yfxn">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/yfxn.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">研发效能</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="yhyzf">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/yhyzf.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">用户与支付</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="xfcjyf">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/xfcjyf.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">消费场景研发</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="sssj">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/sssj.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">实时数据</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="ywztyf">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/ywztyf.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">业务中台研发</p>
                </router-link>
              </li>
              <li class="tabs-item" data-key="ydzt">
                <router-link to="./index">
                  <div class="tabs-item-icon">
                    <img :src="require('@/assets/imgs/index/ydzt.svg')" alt="">
                  </div>
                  <p class="tabs-item-title">移动中台</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="hot-content">
        <div class="tabs-content">
          <div class="tabs-pannel tabs-pannel-jcjg">
            <ul class="ai-list">
              <li class="ai-item">
                <router-link :to="{name:'das'}" target="_blank">
                  <div class="item-title">DAS数据库访问框架</div>
                  <div class="item-content">信也科技自研的关系型数据库访问框架。支持数据库管理，ORM，动态SQL构建，分库分表等功能</div>
                </router-link>
              </li>
              <li class="ai-item">
                <div class="item-title">PMQ消息中间件</div>
                <div class="item-content">信也科技自研的分布式消息系统，具有部署运维简单、监控治理丰富，能够最大限度保证消息不丢失等特性</div>
              </li>
              <li class="ai-item">
                <div class="item-title">星云多环境系统</div>
                <div class="item-content">快速、低成本拉起大量相互隔离的测试环境，提升测试效率</div>
              </li>
              <li class="ai-item">
                <router-link :to="{name:'cloud'}" target="_blank">
                  <div class="item-title">Stargate容器云管理平台</div>
                  <div class="item-content">容器发布、管理平台。支持JAVA、Python、NodeJS、Flink等多种应用，并通过OpenAPI支撑上层的CI/CD、自动发布、环境管理等生态应用</div>
                </router-link>
              </li>
              <li class="ai-item">
                <div class="item-title">谛听全链路监控平台</div>
                <div class="item-content">一站式全链路排障工具，通过链路实时展示、多维指标分析等功能，提升了故障的定位及诊断的效率</div>
              </li>
              <li class="ai-item">
                <div class="item-title">更多基础架构产品</div>
                <div class="item-content">
                  优质的可落地技术能力，助力业务突飞猛进
                  <router-link to="./index"><span class="link-detail">查看详情</span></router-link>
                </div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-yfxn">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">数据库自动化运维</div>
                <div class="item-content">标准化数据库研发流程、降低数据库风险、自动化数据库运维</div>
              </li>
              <li class="ai-item">
                <div class="item-title">数据库统一查询平台</div>
                <div class="item-content">提供全环境、多终端、权限可控、自动脱敏、可审计的一站式查询平台</div>
              </li>
              <li class="ai-item">
                <div class="item-title">代码扫描平台</div>
                <div class="item-content">提供代码准入库检查、代码缺陷自动发现、代码安全检查、代码依赖包拦截等功能</div>
              </li>
              <li class="ai-item">
                <div class="item-title">分支管理平台</div>
                <div class="item-content">标准化分支管理流程、分支自动合并、分支反向合并、代码评审流程、分支生命周期管理等功能</div>
              </li>
              <li class="ai-item">
                <div class="item-title">持续集成平台</div>
                <div class="item-content">支持各种语言的构建、支持虚拟及Docker环境、支持自动构建及发布能力</div>
              </li>
              <li class="ai-item">
                <div class="item-title">更多研发效能产品</div>
                <div class="item-content">
                  优质的可落地技术能力，助力业务突飞猛进
                  <router-link to="./index"><span class="link-detail">查看详情</span></router-link>
                </div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-yhyzf">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">数字营销</div>
                <div class="item-content">根据活动场景、用户画像 智能推荐灰度策略、活动奖品，根据活动效果实时调整的一站式的营销平台</div>
              </li>
              <li class="ai-item">
                <div class="item-title">银聚通</div>
                <div class="item-content">为外部商户提供聚合式银行理财服务，亦帮助银行提供销售其理财产品的渠道，实现能力输出</div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-xfcjyf">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">企业微信中台</div>
                <div class="item-content">构建企业的客户管理工具，提供私域流量运营的通用能力，帮助企业更好得触达用户、提供服务、沉淀客户关系，同时实现企业微信管理工具的SAAS和私有化部署</div>
              </li>
              <li class="ai-item">
                <div class="item-title">智能展业地图</div>
                <div class="item-content">实时展示全国的销售业绩情况及销售的展业情况，帮助销售更好的管理团队和展业选址、未来可结合智能推荐自动化完成销售展业指导</div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-sssj">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">实时报表平台</div>
                <div class="item-content">一站式、自助化实时数据服务平台，PB级数据亚秒级处理；动态可视化、实时监测，使大数据流式处理更加轻量、敏捷、可控可靠。</div>
              </li>
              <li class="ai-item">
                <div class="item-title">datacloud计算平台</div>
                <div class="item-content">Datacloud是一个提供大数据离线数据调度一站式解决方案,有效管理任务的开发、调度、依赖、资源分配、优先级及监控的分布式任务调度管理平台</div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-ywztyf">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">PMS营销系统</div>
                <div class="item-content">一体化的营销平台。通过构建用户全域画像，运用人机协同等方案，实现精准营销和智能运营，提升转化率和留存</div>
              </li>
              <li class="ai-item">
                <div class="item-title">魔方</div>
                <div class="item-content">魔方是一站式、自助化的机构资金管理平台，可快速实现资方系统的标准化接入、自动化模拟测试、以及可视化的资方运营管理</div>
              </li>
            </ul>
          </div>
          <div class="tabs-pannel tabs-pannel-ydzt">
            <ul class="ai-list">
              <li class="ai-item">
                <div class="item-title">神庙渠道管理平台</div>
                <div class="item-content">App市场投放一体化管理平台， 集成渠道追踪、RTA信息投放等行业尖端能力，实现高QPS、高稳定性，支持渠道、策略、财务的一站式管理</div>
              </li>
              <li class="ai-item">
                <div class="item-title">智能投放平台</div>
                <div class="item-content">集成了投放渠道管理、前置流量筛选、大数据智能渠道归因、广告媒体对接等一系列核心广告投放能力</div>
              </li>
              <li class="ai-item">
                <div class="item-title">LC发控平台</div>
                <div class="item-content">App各渠道发布全流程产品自助化管理平台，支持多产品、多维度发布管理；支持智能灰度能力，多种升级策略</div>
              </li>
              <li class="ai-item">
                <div class="item-title">消息推送平台</div>
                <div class="item-content">提供专业的移动消息推送方案，支持多厂商渠道、短信、微信等多纬度推送策略，提高用户留存率，提升用户体验</div>
              </li>
              <li class="ai-item">
                <div class="item-title">神笔活动平台</div>
                <div class="item-content">活动在线自助投放平台。实现&lt;0.8s、所见即所得、多形态、全周期、多租户，是超一线的用户营销系统</div>
              </li>
              <li class="ai-item">
                <div class="item-title">更多移动中台产品</div>
                <div class="item-content">
                  优质的可落地技术能力，助力业务突飞猛进
                  <router-link to="./index"><span class="link-detail">查看详情</span></router-link>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 背景色条 -->
    <section class="section-bgBar"></section>
    <!-- 功能强大的解决方案 -->
    <section class="section-solution">
      <div class="inner">
        <div class="title"><span>功能强大的解决方案</span></div>
        <div class="subtitle">深耕业务场景，提升业务能效，助力业务增长</div>
        <ul class="list">
          <li class="list-item">
            <div class="item-title">自动化机器人</div>
            <div class="item-category">
              <router-link to="./index"><p>语音机器人</p></router-link>
              <router-link to="./index"><p>文本机器人</p></router-link>
            </div>
            <div class="item-icon">
              <img :src="require('@/assets/imgs/index/zdhjqr.svg')" alt="">
            </div>
          </li>
          <li class="list-item">
            <div class="item-title">算法模型</div>
            <div class="item-category">
              <router-link to="./index"><p>情绪模型</p></router-link>
              <router-link to="./index"><p>闲聊模型</p></router-link>
              <router-link to="./index"><p>深度学习NLP建模平台</p></router-link>
            </div>
            <div class="item-icon">
              <img :src="require('@/assets/imgs/index/sfmx.svg')" alt="">
            </div>
          </li>
          <li class="list-item">
            <div class="item-title">智能平台&系统</div>
            <div class="item-category">
              <router-link to="./index"><p>明镜反欺诈系统</p></router-link>
              <router-link :to="{name:'kraken'}" target="_blank"><p class="existing">章鱼流量投放平台</p></router-link>
              <router-link :to="{name:'three'}" target="_blank"><p class="existing">三方数据管理平台</p></router-link>
              <router-link to="./index"><p>9¾模型服务平台</p></router-link>
              <router-link to="./index"><p>犀牛质检平台</p></router-link>
            </div>
            <div class="item-icon">
              <img :src="require('@/assets/imgs/index/znpt.svg')" alt="">
            </div>
          </li>
          <li class="list-item">
            <div class="item-title">研发运维技术栈</div>
            <div class="item-category">
              <router-link to="./index"><p>信贷云</p></router-link>
            </div>
            <div class="item-icon">
              <img :src="require('@/assets/imgs/index/yfywjsz.svg')" alt="">
            </div>
          </li>
        </ul>
      </div>
    </section>
    <!-- 时事动态 -->
    <section class="section-news">
      <div class="inner">
        <div class="title"><span>时事动态</span></div>
        <div class="subtitle">信也动态，尽在掌握</div>
        <ul class="news">
          <li class="news-item">
            <a href="//mp.weixin.qq.com/s/rpNL2qOF8AaaOmP8qnYHeQ" target="_blank">
              <section class="news-image">
                <img :src="require('@/assets/imgs/index/news1.svg')" alt="">
              </section>
              <section class="news-content">
                <div class="item-title">全国政协委员调研团走进信也科技</div>
                <div class="item-content">
                  9月3日至4日，全国政协委员调研团来到了国内金融科技公司信也科技（NYSE:FINV），开展了以“科技驱动，助力经济”为主题的调研之行。本次调研由人民政协报社主办，在调研过程中，委员们表达了对于金融科技行业发展方向的看法，并同与会的嘉宾及企业代表进行了深入交流与探讨。 
                </div>
                <div class="item-detail">
                  <a href="//mp.weixin.qq.com/s/rpNL2qOF8AaaOmP8qnYHeQ" target="_blank"><span>阅读全文</span></a>
                </div>
              </section>
            </a>
          </li>
          <li class="news-item">
            <a href="//mp.weixin.qq.com/s/RMGb_TcttS17InOUXoslQQ" target="_blank">
              <section class="news-image">
                <img :src="require('@/assets/imgs/index/news2.svg')" alt="">
              </section>
              <section class="news-content">
                <div class="item-title">市经信委副主任张英一行赴信也科技集团调研</div>
                <div class="item-content">
                  9月15日，上海市经济和信息化委员会副主任张英、软件和信息服务业处副处长孙德功和人工智能处副处长孙跃，共赴金融科技公司信也科技集团总部进行调研。信也科技创始人、总裁李铁铮与副总裁陈磊就信也科技发展的相关情况进行了详细汇报。
                </div>
                <div class="item-detail">
                  <a href="//mp.weixin.qq.com/s/RMGb_TcttS17InOUXoslQQ" target="_blank"><span>阅读全文</span></a>
                </div>
              </section>
            </a>
          </li>
          <li class="news-item">
            <a href="//mp.weixin.qq.com/s/Y3k4Q7oTDF9atjszpe75Ow" target="_blank">
              <section class="news-image">
                <img :src="require('@/assets/imgs/index/news3.svg')" alt="">
              </section>
              <section class="news-content">
                <div class="item-title">信也科技联合上海公安打击电信诈骗</div>
                <div class="item-content">
                  金融科技公司信也科技（NYSE:FINV）利用自身在AI、大数据及互联网技术领域的优势，自2020年4月起，与上海公安在反欺诈领域开启了密切合作，双方共同建立了反诈宣传、事前预警、事中阻断和事后追踪全流程反诈协同机制，并已取得了初步成果。
                </div>
                <div class="item-detail">
                  <a href="//mp.weixin.qq.com/s/Y3k4Q7oTDF9atjszpe75Ow" target="_blank"><span>阅读全文</span></a>
                </div>
              </section>
            </a>
          </li>
        </ul>
        <div class="news-more">
          <router-link to="./index"><span>查看更多时事动态</span></router-link>
        </div>
      </div>
    </section>
    <!-- 时事动态 -->
    <section class="section-techCup">
      <div class="cup-image">
         <img :src="require('@/assets/imgs/index/cup-logo.svg')" alt="">
      </div>
      <div class="cup-content">
        <img :src="require('@/assets/imgs/index/quote.svg')" alt="">
        <div class="cup-intro">
          信也科技杯数据应用大赛是一场综合能力的角逐。信也科技提供丰富资源、奖金向您征集金融科技领域内的各类解决方案。我们邀请优秀的你，利用这些资源打造一款数据产品，满足投资者需求，并上线提供给投资者使用，有其直接的商业价值。优秀作品团队更有机会直接获得天使投以及信也科技提供的孵化方案。
        </div>
        <div class="cup-detail">
          <router-link to="./index"><span>查看详情 ></span></router-link>
        </div>
      </div>
    </section>
  </article>
</template>
<script>
import { reactive, onMounted, toRefs, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { indexUtils } from '@/utils/interaction'
import 'swiper/swiper-bundle.css'

//第一步-导入swiper组件
import { Swiper, SwiperSlide } from 'swiper/vue'
//第二步-导入插件
import SwiperCore, { Pagination,Autoplay,Navigation } from 'swiper' 
//第三步-使用插件（同时在模板中swiper标签使用）
SwiperCore.use([Pagination,Autoplay,Navigation]) 

export default {
  name: 'index',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      headerScroll: false,
      currentPannelTitle: 0,
      pannelTitleList:[
        { value: 'product', label: 'AI产品' },
        { value: 'dev', label: '研发运维产品' },
        { value: 'dev1', label: '研发运维产品1' },
        { value: 'dev2', label: '研发运维产品2' },
      ],
      swiperList:[
        { key:'2', banner:'future', imgUrl:'//ai.ppdai.com/resource/img/index/banner-future.png'},
        { key:'3', banner:'robot', imgUrl:'//ai.ppdai.com/resource/img/index/banner-robot.png'},
      ],
    });
    nextTick(() => {
      window.addEventListener('scroll', () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        scrollTop > 60 ? state.headerScroll = true : state.headerScroll = false
      })
    })
    const setPannelTitleAcive = (idx) => {
      state.currentPannelTitle = idx;
    }
    const onSwiper = (swiper) => {
      state.swiper = swiper;
      console.log(swiper)
    };
    const onSlideChange = () => {
      console.log('slide change')
    };
    onMounted(() => {
      indexUtils();
    })
    const gotoProductDetail = (name) =>{
      let routeData = router.resolve({name, query: {}});
      window.open(routeData.href, '_blank');
    }
    return {
      ...toRefs(state),
      setPannelTitleAcive,
      onSwiper,
      onSlideChange,
      gotoProductDetail,
    };
  }
}
</script>
<style scoped lang="scss">
  .index-container{
    .section-swiper{
      .swiper-container{
        .swiper-wrapper{
          .swiper-slide{
            .banner{
              width:100%;
              min-height: 600px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              .inner{
                position: relative;
                width: 1182px;
                margin: 0 auto;
                display: flex;
                .left{
                  .title{
                    font-family: PingFangSC-Regular;
                    font-size: 54px;
                    line-height: 1;
                    color: #FFFFFF;
                    margin-bottom: 44px;
                  }
                  .subtitle{
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    line-height: 1;
                    color: #FFFFFF;
                    margin-bottom: 40px;
                  }
                  .btn-detail{
                    display: inline-block;
                    width: 140px;
                    height: 40px;
                    line-height:40px;
                    background: #467CFD;
                    text-align: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #FFFFFF;
                    letter-spacing: 0;
                  }
                }
                .right{
                  margin-left: auto;
                }
              }					
            }
            .banner-cup{
              background: #00172b url(~@/assets/imgs/index/banner-cup.svg) no-repeat center;
              background-size: cover;
              .inner{
                justify-content: center;
                align-items: center;
              }
            }
            .banner-face,.banner-feature,.banner-speak{
              background: #202631 url(~@/assets/imgs/index/banner-texture.png) no-repeat bottom;
              background-size: 100% 22%;
              .inner{
                align-items: center;
              }
            }
            .banner-into{
              background: #1F2531 url(~@/assets/imgs/index/banner-into.png) no-repeat center;
              background-size: cover;
              .inner{
                justify-content: center;
                align-items: center;
                .line{
                  text-align: center;
                  .title{
                    font-size: 36px;
                    margin-bottom: 28px;
                  }
                }
              }
            }
          }
        }
      }
    }

    .section-star{
      background: #FFFFFF;
      padding: 63px 0 73px;
      .inner{
        width: 1182px;
        margin: 0 auto;
        .title{
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #0D1A26;
          letter-spacing: 0;
          line-height: 32px;
          padding:  0 0 13px 0;
          position: relative;
          span{
            position: relative;
            &::after{
              content: '';
              width: 30px;
              height: 2px;
              position: absolute;
              left: 48px;
              bottom: -10px;
              background-image: linear-gradient(39deg, #3B70FE 0%, #1A3DED 100%);
            }
          }
        }
        .subtitle{
          text-align: center;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #777777;
          letter-spacing: 0;
          line-height: 14px;
          padding: 20px 0 24px;
        }
        .mode-list{
          height: 400px;
          .mode-item{
            width: 200px;
            height: 400px;
            float: left;
            overflow: hidden;
            margin-left: -1px;
            background: #F9FCFE 100%;
            transition: width .4s;
            margin: 0 10px 0 0;
            border-top: solid 4px #8BAEF7;
            &.mode-item-active{
              cursor: pointer;
              width: 710px;
              border: none;
              .mode-wrap {
                margin-left: -200px;
                opacity: 1;
                .mode-view {
                  opacity: 0;
                }
                .mode-detail{
                  opacity: 1;
                }
              }
            }
            &:last-child{
              margin: 0;
            }
            .mode-wrap{
              width: 910px;
              height: 400px;
              .mode-view{
                cursor: pointer;
                float: left;
                width: 200px;
                height: 400px;
                opacity: 1;
                .view-title{
                  font-family: PingFangSC-Medium;
                  font-size: 20px;
                  color: #0D1A26;
                  letter-spacing: 0;
                  line-height: 20px;
                  padding: 38px 0 37px 20px;
                }
                .view-desc{
                  font-family: PingFangSC-Regular;
                  font-size: 15px;
                  color: #7A8690;
                  letter-spacing: 0;
                  line-height: 24px;
                  padding: 0 20px;
                }
              }
              .mode-detail{
                float: left;
                color: #FFFFFF;
                width: 710px;
                height: 400px;
                background: #467CFD;
                opacity: 0;
                // padding: 42px 0 42px 40px;
                padding: 42px 0 0 0;
                box-sizing: border-box;
                .detail-title{
                  padding: 0 0 21px 40px;
                  font-family: PingFangSC-Medium;
                  font-size: 20px;
                  color: #FFFFFF;
                  letter-spacing: 0;
                  line-height: 20px;
                }
                .detail-desc{
                  padding: 0 0 20px 40px;
                  font-family: PingFangSC-Medium;
                  font-size: 15px;
                  color: #D7E6FF;
                  letter-spacing: 0;
                  line-height: 15px;
                }
                .detail-content{
                  padding: 0 0 0 30px;
                  .ai-list{
                    display: flex;
                    flex-wrap: wrap;
                    flex: 1;
                    .ai-item{
                      cursor: pointer;
                      display: flex;
                      flex-direction: column;
                      width: 315px;
                      // padding: 0 61px 30px 0;
                      padding: 10px 10px 17px;
                      margin: 0 30px 6px 0;
                      height: max-content;
                      &:nth-child(even) {
                        margin: 0 20px 6px 0;
                      }
                      .item-title{
                        text-align: left;
                        padding-bottom: 15px;
                        display: flex;
                        align-items: center;
                        font-family: PingFangSC-Medium;
                        font-size: 14px;
                        color: #FFFFFF;
                        letter-spacing: 0;
                        line-height: 14px;
                      }
                      .item-content{
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        color: #D7E6FF;
                        letter-spacing: 0;
                        line-height: 1.2;
                      }
                    }
                    .existing{
                      &:hover{
                        background: #FFFFFF;
                        .item-title{
                          color: #467CFD;
                        }
                        .item-content{
                          color: #467CFD;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    .section-hot{
      background: #FFFFFF;
      .hot-head{
        padding: 60px 0 0;
        .inner{
          width: 1140px;
          margin: 0 auto;
          text-align: center;
          .title{
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #2E3449;
            letter-spacing: 0;
            line-height: 24px;
            padding: 0 0 15px 0;
          }
          .subtitle{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #9196A6;
            letter-spacing: 0;
            line-height: 24px;
          }
          .tabs-bar{
            .tabs-list{
              display: flex;
              justify-content: center;
              padding: 27px 0 26px;
              border-bottom: solid 4px #E6EEFD;
              .tabs-item{
                &.tabs-item-active{
                  &::before{
                    opacity: 1;
                    visibility: visible;
                  }
                }
                &::before{
                  content: '';
                  position: absolute;
                  left: 0;
                  bottom: -30px;
                  border-bottom: solid 4px #467CFD;
                  width: 100%;
                  opacity: 0;
                  visibility: hidden;
                  transition: opacity .2s;
                }
                position: relative;
                width: calc((100% - 1px)/ 7);
                text-align: center;
                font-size: 0;
                .tabs-item-icon{
                  img{
                    width: 48px;
                    height: 48px;
                  }
                }
                .tabs-item-title{
                  display: block;
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #2E3449;
                  letter-spacing: 0;
                  line-height: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-top: 20px;
                  transition: all .2s linear;
                  -webkit-font-smoothing: antialiased;
                }
              }
            }
          }
        }
      }
      .hot-content{
        box-shadow: 0 -2px 0 0 rgba(139,174,247,0.02), 0 -2px 50px 0 rgba(139,174,247,0.14);
        margin: -2px 0 0;
        .tabs-content{
          width: 1140px;
          min-height: 380px;
          margin: 0 auto;
          padding: 35px 0 50px;
          .tabs-pannel{
            display: none;
            &:first-child{
              display: initial;
            }
            .ai-list{
              display: flex;
              flex-wrap: wrap;
              .ai-item{
                cursor: pointer;
                display: flex;
                flex-direction: column;
                width: 330px;
                margin: 0 65px 55px 0;
                height: max-content;
                &:nth-child(3n) {
                  margin: 0 0 30px 0;
                }
                .item-title{
                  text-align: left;
                  padding-bottom: 24px;
                  align-items: center;
                  font-family: PingFangSC-Medium;
                  font-size: 16px;
                  color: #0D1A26;
                  letter-spacing: 0;
                  line-height: 16px;
                }
                .item-content{
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #8292A2;
                  letter-spacing: 0;
                  line-height: 22px;
                  .link-detail{
                    display: block;
                    margin-top: 24px;
                    color: #2F54EB;
                  }
                }
              }
            }
          }
        }
      }
    }

    .section-bgBar{
      width: 100%;
      height: 69px;
      background: #467CFD;
    }

    .section-solution{
      position: relative;
      width: 100%;
      min-height: 560px;
      padding: 52px 0 72px;
      &::after{
        content: "";
        background: #323A4E url(~@/assets/imgs/index/bg-solution.png)  no-repeat center;
        background-size: cover;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: -1;  
      }
      .inner{
        width: 1182px;
        margin: 0 auto;
        .title{
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #FFFFFF;
          letter-spacing: 0;
          line-height: 32px;
          padding:  0 0 13px 0;
          span{
            position: relative;
            &::after{
              content: '';
              width: 30px;
              height: 2px;
              position: absolute;
              left: 45%;
              bottom: -10px;
              background-image: linear-gradient(39deg, #3B70FE 0%, #1A3DED 100%);
            }
          }
        }
        .subtitle{
          text-align: center;
          padding: 20px 0 35px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #D1D1D1;
          letter-spacing: 0;
          line-height: 14px;
        }
        .list{
          display: flex;
          justify-content: center;
          .list-item{
            position: relative;
            width: 280px;
            height: 320px;
            margin: 0 20px 0 0;
            padding: 50px 0 30px 40px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: 0 10px 20px 0 #2C334B;
            border-radius: 4px;
            border-radius: 4px;
            &:last-child{
              margin:0;
            }
            .item-title{
              font-family: PingFangSC-Medium;
              font-size: 20px;
              color: #0D1A26;
              letter-spacing: 0;
              line-height: 20px;
            }
            .item-category{
              padding: 31px 0 0 0;
              p{
                margin: 0 0 16px 0;
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #7A8690;
                line-height: 14px;
              }
              .existing:hover{
                color: #467CFD;
              }
              a:last-child{
                p{
                  margin: 0;
                }
              }
            }
            .item-icon{
              font-size: 0;
              position: absolute;
              right: 30px;
              bottom: 30px;
            }
            &:nth-child(2){
              .item-icon{
                right: 23px;
                bottom: 30px;
              }
            }
            &:nth-child(4){
              .item-icon{
                right: 20px;
                bottom: 30px;
              }
            }
          }
        }
      }
    }

    .section-news{
      position: relative;
      width: 100%;
      padding: 63px 0 0;
      box-sizing: border-box;
      background: #FFFFFF;
      .inner{
        width: 1182px;
        margin: 0 auto;
        .title{
          text-align: center;
          font-family: PingFangSC-Medium;
          font-size: 32px;
          color: #2E3449;
          letter-spacing: 0;
          line-height: 32px;
          padding:  0 0 13px 0;
          span{
            position: relative;
            &::after{
              content: '';
              width: 30px;
              height: 2px;
              position: absolute;
              left: 48px;
              bottom: -10px;
              background-image: linear-gradient(39deg, #3B70FE 0%, #1A3DED 100%);
            }
          }
        }
        .subtitle{
          text-align: center;
          padding: 20px 0 35px;
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #9196A6;
          letter-spacing: 0;
          line-height: 14px;
        }
        .news{
          .news-item{
            cursor: pointer;
            position: relative;
            width: 1180px;
            min-height: 210px;
            margin: 0 0 30px 0;
            box-shadow: 0 0 4px 0 rgba(240,245,253,0.89);
            border-radius: 2px;
            border-radius: 2px;
            display: flex;
            overflow: hidden;
            &>a{
              display: inline-flex;
            }
            &:last-child{
              margin:0;
            }
            &:hover{
              box-shadow: 0 6px 16px 0 rgba(201,215,243,0.70);
              .news-image{
                -webkit-transform: scale(1.1);
                -moz-transform: scale(1.1);
                -ms-transform: scale(1.1);
                transform: scale(1.1)
              }
            }
            .news-image{
              width: 300px;
              -webkit-transform-origin: 50% 50%;
              -moz-transform-origin: 50% 50%;
              -ms-transform-origin: 50% 50%;
              transform-origin: 50% 50%;
              -webkit-transition: -webkit-transform .2s;
              transition: -webkit-transform .2s;
              -moz-transition: transform .2s,-moz-transform .2s;
              transition: transform .2s;
              transition: transform .2s,-webkit-transform .2s,-moz-transform .2s;
              img{
                width: 300px;
                height: 210px;
                vertical-align: top;
              }
            }
            .news-content{
              flex: 1;
              padding: 30px 40px 24px 40px;
              box-sizing: border-box;
              .item-title{
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #2E3449;
                line-height: 20px;
                padding: 0 0 24px 0;
              }
              .item-content{
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #9196A6;
                line-height: 20px;
              }
              .item-detail{
                font-size: 0;
                position: absolute;
                right: 40px;
                bottom: 20px;
                a{
                  display: inline-block;
                  width: 90px;
                  height: 34px;
                  line-height:34px;
                  background: #467CFD;
                  text-align: center;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #FFFFFF;
                  letter-spacing: 0;
                }
              }
            }
          }
        }
        .news-more{
          padding: 50px 0 53px;
          text-align: center;
          a{
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #467CFD;
            letter-spacing: 0;
            line-height: 14px;
          }
        }
      }
    }

    .section-techCup{
      display: flex;
      height: 280px;
      .cup-image{
        flex: 1;
        position: relative;
        &::after{
          content: "";
          background: url(~@/assets/imgs/index/bg-cup.png) no-repeat center;
          background-size: cover;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          position: absolute;
          z-index: -1;  
        }
        img{
          position: absolute;
          top: 80px;
          right: 140px;
        }
      }
      .cup-content{
        flex: 1;
        position: relative;
        padding: 71px 0 0 105px;
        background: #467CFD;
        img{
          position: absolute;
          top: 47px;
          left: 55px;
        }
        .icon-intro{
          height: 20px;
          position: absolute;
          top: 47px;
          left: 55px;
        }
        .cup-intro{
          width: 485px;
          font-family: PingFangSC-Regular;
          font-size: 15px;
          color: #FFFFFF;
          letter-spacing: 1.07px;
          line-height: 24px;
        }
        .cup-detail{
          padding: 20px 0 0;
          a{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #FFFFFF;
            letter-spacing: 0;
            line-height: 14px;
          }
        }
      }
    }
  }
</style>
